import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProfessionalAudience } from './components/ProfessionalAudience';
import { StatsBar } from './components/StatsBar';
import { TestimonialStrip } from './components/TestimonialStrip';
import { Problems } from './components/Problems';
import { Modules } from './components/Modules';
import { ModuleIncludes } from './components/ModuleIncludes';
import { Comparison } from './components/Comparison';
import { Bonuses } from './components/Bonuses';
import { PricingPack } from './components/PricingPack';
import { Guarantee } from './components/Guarantee';
import { Reviews } from './components/Reviews';
import { CostOfNotBuying } from './components/CostOfNotBuying';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
type MetaPixel = ((...args: unknown[]) => void) & {
  queue?: unknown[][];
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixel;
    _fbq?: MetaPixel;
  }
}
const META_PIXEL_ID = '2316514158879594';
export function App() {
  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }
    const fbq: MetaPixel = (...args: unknown[]) => {
      fbq.queue?.push(args);
    };
    fbq.queue = [];
    fbq.loaded = true;
    fbq.version = '2.0';
    window.fbq = fbq;
    window._fbq = fbq;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    fbq('init', META_PIXEL_ID);
    fbq('track', 'PageView');
  }, []);
  return <main className="w-full overflow-x-hidden bg-surface font-sans text-ink antialiased" data-id="element-0" data-mp="3dkuwe4m2tksa">
      <noscript data-id="element-1" data-mp="3dii694660445">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="nvstj3irmlvf" />
      </noscript>
      <Hero data-id="element-3" data-mp="35gkl05ue1ig" />
      <ProfessionalAudience data-id="element-4" data-mp="356r32ll9c80" />
      <StatsBar data-id="element-5" data-mp="38kvshhq5xim" />
      <TestimonialStrip data-id="element-6" data-mp="3uct2xiigokzy" />
      <Problems data-id="element-7" data-mp="3udkoe0ich2ci" />
      <Modules data-id="element-8" data-mp="3ubzsa6gdtbcj" />
      <ModuleIncludes data-id="element-9" data-mp="3ucjc5sple9t7" />
      <Comparison data-id="element-10" data-mp="3uf5gzkl3mb7q" />
      <Bonuses data-id="element-11" data-mp="d4e57s05daw6" />
      <PricingPack data-id="element-12" data-mp="d4xqnip0ahey" />
      <Guarantee data-id="element-13" data-mp="d3cwhu6lt0hm" />
      <Reviews data-id="element-14" data-mp="d3wax0x1p6qw" />
      <CostOfNotBuying data-id="element-15" data-mp="d2bgrcen7ptk" />
      <FAQ data-id="element-16" data-mp="851kbcsu6dw8" />
      <FinalCTA data-id="element-17" data-mp="85bdf996h165" />
      <Footer data-id="element-18" data-mp="86w76wno4g2y" />
    </main>;
}